export default __webpack_public_path__ + "static/media/img2.c9f811ef.png";